export const SS = "SS";
export const FS = "FS";
